import { render, staticRenderFns } from "./MakeupArtistApplicationCard.vue?vue&type=template&id=6264dd2c&scoped=true&"
import script from "./MakeupArtistApplicationCard.vue?vue&type=script&lang=js&"
export * from "./MakeupArtistApplicationCard.vue?vue&type=script&lang=js&"
import style0 from "./MakeupArtistApplicationCard.vue?vue&type=style&index=0&id=6264dd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264dd2c",
  null
  
)

export default component.exports